
        var result = require("!!../../../../../node_modules/css-loader/dist/cjs.js!./ups-fileUpload.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    